// tipoTechoService.js
import api from './api';

export const tipoTechoService = {
    obtenerTodos: () => api.get('/get/obtener_tipostecho.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        }))
};
